export const size = {
  xs: 5,
  sm: 10,
  md: 15,
  lg: 20,
  ex: 30
} as const

export type Size = keyof typeof size
